import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

const Card = ({ children, className, padding, style }) => (
  <S.Wrapper className={cn('card-wrapper', className)} style={style} padding={padding}>
    {children}
  </S.Wrapper>
);

Card.S = S;

Card.propTypes = PropTypes.shape({
  children: PropTypes.node,
  className: PropTypes.string,
  padding: PropTypes.string,
  style: PropTypes.object
});

export { Card };
